export default __webpack_public_path__ + "static/media/UserIconInactive.691289cc.svg";